import { LoadingStateV2 } from "#src/commonV2/LoadingState";
import { SectionCard } from "#src/commonV2/SectionCard";
import { TableV2 } from "#src/commonV2/Table";
import { IPricingInfo } from "#src/services/payment/types";
import { planDurationToUserFriendlyString } from "#src/utils/apiHelper";
import { DateTime } from "luxon";
import { useTranslation } from "react-i18next";

interface IPaymentEnterInformationCheckYourCartProps {
  calculatedPricing: IPricingInfo;
}

export const PaymentEnterInformationCheckYourCart = ({
  calculatedPricing,
}: IPaymentEnterInformationCheckYourCartProps) => {
  const { t, i18n } = useTranslation("common", {
    keyPrefix: "v2.payment.enterInformation.checkYourCart",
  });

  const locale = i18n.language;

  // --------------- METHODS ---------------

  // --------------- RENDER ---------------

  return (
    <SectionCard header={t("title")}>
      <div className="p-4 rounded-xl bg-white border border-gray-v2-200">
        {calculatedPricing === null ? (
          <LoadingStateV2 />
        ) : (
          // TODO: add a column for delete and edit button
          // if there's only 1 product, hide all delete button
          // Edit button should only show on buying things, not renew or upgrade
          <TableV2<IPricingInfo["product_plans"][number]>
            data={calculatedPricing.product_plans}
            getRowKey={(item) => item.product.id}
            columns={[
              {
                title: t("header.productService"),
                render: (item) =>
                  locale === "vi" ? item.product.name.vi : item.product.name.en,
                overwriteWrapperProps: {
                  className: "font-medium text-gray-v2-900",
                },
                gridTemplateValue: "4fr",
              },
              {
                title: t("header.solution"),
                render: (item) =>
                  locale === "vi"
                    ? item.product.category.name.vi
                    : item.product.category.name.en,
                overwriteWrapperProps: {
                  className: "font-medium text-gray-v2-900",
                },
                gridTemplateValue: "3fr",
              },
              {
                title: t("header.plan"),
                render: (item) =>
                  locale === "vi" ? item.name?.vi : item.name?.en,
                gridTemplateValue: "3fr",
              },
              {
                title: t("header.cycle"),
                render: (item) =>
                  planDurationToUserFriendlyString(item.duration),
                gridTemplateValue: "2fr",
              },
              {
                title: t("header.estimated"),
                render: (item) => item.price.toLocaleString() + " VND",
                gridTemplateValue: "2fr",
              },
              {
                title: t("header.nextRenewalDate"),
                render: (item) =>
                  DateTime.fromSeconds(item.next_billing_time).toFormat(
                    "dd/MM/yyyy"
                  ),
                gridTemplateValue: "2fr",
              },
            ]}
          />
        )}
      </div>
    </SectionCard>
  );
};
